import { View } from 'react-native'

const SEGMENT_HEIGHT = 4
const SEGMENT_GAP = 3
const SEGMENT_RADIUS = 2
const INACTIVE_COLOR = '#d1d5db'

export function SessionStepIndicator({
  stepKeys,
  currentStepIndex,
  activeColor,
}: {
  stepKeys: string[]
  currentStepIndex: number
  activeColor: string
}) {
  const totalSteps = stepKeys.length
  if (totalSteps <= 0) return null

  return (
    <View className="w-full flex-row items-center" style={{ gap: SEGMENT_GAP }}>
      {stepKeys.map((stepKey, idx) => (
        <View
          key={stepKey}
          style={{
            flex: 1,
            height: SEGMENT_HEIGHT,
            borderRadius: SEGMENT_RADIUS,
            backgroundColor:
              idx <= currentStepIndex ? activeColor : INACTIVE_COLOR,
          }}
        />
      ))}
    </View>
  )
}
